<template>
    <div>
        <el-row :gutter="30">
            <el-col :span="6" class="sidebar">
                <router-link :to="{name: 'Add StandCategory'}">
                    <el-button type="primary" class="fluid">{{ $t('add') }} Kategorię <i class="el-icon-plus"></i>
                    </el-button>
                </router-link>
                <ListFilterComponent @setFilter="setFilter"
                                     :selectedFilters="filters.selected"
                                     :listFilters="filters.available">
                </ListFilterComponent>
            </el-col>
            <el-col class="box" :span="18">
                <div class="list__header">
                    <p class="list__title">
                        {{ getRouteName($route) }}
                    </p>
                    <search-list-form v-model="filters.selected.search"
                                      @submit="fetchData"/>
                </div>
                <el-table :data="data"
                          highlight-current-row
                          v-loading="listLoading"
                          class="list__table"
                          style="width: 100%;">
                    <el-table-column prop="id" label="id" width="80"></el-table-column>
                    <el-table-column prop="name_pl" label="nazwa (pl)"></el-table-column>
                    <el-table-column prop="name_en" label="nazwa (en)"></el-table-column>
                    <el-table-column label="opcje" width="150" class="pull-right">
                        <template slot-scope="scope" class="pull-right">
                            <router-link :to="{name: 'Edit StandCategory', params: {id: scope.row.id}}">
                                <el-button size="small" :title="$t('edit')">
                                    <i class="el-icon-edit"></i>
                                </el-button>
                            </router-link>
                            <el-button type="danger"
                                       size="small"
                                       :title="$t('delete')"
                                       @click="handleDelete(scope.$index, scope.row)"><i
                                    class="el-icon-delete"></i>
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>
    </div>
</template>
<script>
    import {StandCategory} from '@/api/';
    import ListFilterComponent from '@/components/ListFilterComponent'

    export default {
        data () {
            return {
                filters: {
                    available: [],
                    selected: {}
                },
                data: [],
                listLoading: false,
                service: StandCategory
            }
        },
        methods: {
            handlePageChange (val) {
                this.page = val;
                this.fetchData();
            },
            setFilter (filter) {
                this.page = 1
                const key = filter.query_param
                const value = filter.value
                this.$set(this.filters.selected, key, value)
                this.fetchData()
            },
            fetchData () {
                let params = {
                    page: this.page,
                    ...this.filters.selected
                };
                this.listLoading = true;
                this.service.fetch({}, {params}).then(response => {
                    this.data = response.data;
                    this.listLoading = false;
                })
            },
            async handleDelete (index, row) {
                await this.$confirm(this.$i18n.t('deleteConfirmation'), this.$i18n.t('delete'), {
                    type: 'warning'
                })

                this.listLoading = true;
                await this.service.delete(row.id)

                this.listLoading = false;
                this.$message({
                    message: 'Element został usunięty',
                    type: 'success'
                })

                this.fetchData()
            }
        },
        mounted () {
            this.fetchData();
        },
        components: {
            ListFilterComponent
        }
    }
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// CategoriesList.vue?11b95b88